// this file is copied from backend
// https://github.com/Lyearn/LyearnModules_v2/blob/b468164739e8f051909c6675f77e989c8bd71be0/packages/lyearn-classroom-rpc-contract/src/utils/cron/getNextOccurrenceDateFromSchedule.util.ts
// not using directly from backend due to internal dependencies on rpc-contract

import { buildRecurrenceRuleFromSchedule, getUTCDate } from './buildRecurrenceRuleFromSchedule';
import {
  GetNextOccurrenceDateFromScheduleInput,
  GetNextOccurrenceDatesInDateRangeFromScheduleInput,
} from './types';

function getTrueISOString(rruleDate: Date): string {
  const date = rruleDate.getUTCDate();
  const month = rruleDate.getUTCMonth();
  const year = rruleDate.getUTCFullYear();
  const hours = rruleDate.getUTCHours();
  const minutes = rruleDate.getUTCMinutes();

  return new Date(year, month, date, hours, minutes).toISOString();
}

// get next occurrence date in respect to current date or passed reference date with precision upto minutes
export function getNextOccurrenceDateFromSchedule(
  params: GetNextOccurrenceDateFromScheduleInput,
): string[] {
  const rrule = buildRecurrenceRuleFromSchedule(params);
  const nextOccurrenceDates = rrule.all();
  // rrule returns date object with utc offset
  // even though the time is actually in provided timezone and not UTC times.
  // i.e. - 2018-11-01T18:00:00.000Z and provided timezone is `Asia/Kolkata`
  // then the returned time is in correct timezone and Z(UTC) offset is incorrect
  return nextOccurrenceDates.length
    ? nextOccurrenceDates.map((date) => getTrueISOString(date))
    : [];
}

// get next occurrence dates between passed start date and end date
export function getNextOccurrenceDatesInDateRangeFromSchedule({
  schedule,
  options,
}: GetNextOccurrenceDatesInDateRangeFromScheduleInput): string[] {
  const { endDate, startDate, includeStartDate } = options;
  const rrule = buildRecurrenceRuleFromSchedule({ schedule, options });
  const nextOccurrenceDates = rrule.between(
    getUTCDate(new Date(startDate)),
    getUTCDate(new Date(endDate)),
    includeStartDate,
  );
  // rrule returns date object with utc offset
  // even though the time is actually in provided timezone and not UTC times.
  return nextOccurrenceDates.map(getTrueISOString);
}
